import React from "react";

/**
 * ErrorState - Shared error display for admin components
 *
 * @param {string} message - Error message to display
 * @param {string} title - Error title (default: "Error", only shown in non-compact mode)
 * @param {boolean} compact - If true, renders as a card suitable for inline display
 */
function ErrorState({ message, title = "Error", compact = false }) {
  if (compact) {
    return (
      <div className="card mb-4 border-danger" style={{ borderLeftWidth: "4px" }}>
        <div className="card-body">
          <span className="text-danger">
            <i className="fa fa-exclamation-circle me-2" />
            {message}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="alert alert-danger" role="alert">
      <h4 className="alert-heading">{title}</h4>
      <p>{message}</p>
    </div>
  );
}

export default ErrorState;
